const DURATIONS = [
  { value: 'w', label: '온음표', symbol: '𝅝' },
  { value: 'h', label: '2분음표', symbol: '𝅗𝅥' },
  { value: 'q', label: '4분음표', symbol: '♩' },
  { value: '8', label: '8분음표', symbol: '♪' },
]

const RESTS = [
  { value: 'wr', label: '온쉼표', symbol: '𝄻' },
  { value: 'hr', label: '2분쉼표', symbol: '𝄼' },
  { value: 'qr', label: '4분쉼표', symbol: '𝄽' },
  { value: '8r', label: '8분쉼표', symbol: '𝄾' },
]

export default function DurationSelector({ value, onChange }) {
  const isRest = value.includes('r')
  
  return (
    <div className="duration-selector">
      <span className="dur-label">음표 길이</span>
      <div className="dur-section">
        {DURATIONS.map(d => (
          <button
            key={d.value}
            className={`dur-btn ${value === d.value ? 'active' : ''}`}
            onClick={() => onChange(d.value)}
            title={d.label}
          >
            <span className="dur-symbol" aria-hidden>
              {d.symbol}
            </span>
            <span className="dur-name">{d.label}</span>
          </button>
        ))}
      </div>
      
      <span className="dur-label">쉼표</span>
      <div className="dur-section">
        {RESTS.map(r => (
          <button
            key={r.value}
            className={`dur-btn ${value === r.value ? 'active' : ''}`}
            onClick={() => onChange(r.value)}
            title={r.label}
          >
            <span className="dur-symbol" aria-hidden>
              {r.symbol}
            </span>
            <span className="dur-name">{r.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
